// IMPORTANT: bootCleanup must be the FIRST import — it side-effects
// during module evaluation to wipe stale sessionStorage before zustand
// `persist` middleware in sessionStore.ts hydrates from it.
import "./lib/bootCleanup";

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { App } from "./App";
import "./styles/globals.css";

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Missing #root element in index.html");

const tree = (
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// Marketing routes are prerendered to static HTML, so #root already holds
// server markup and must be ADOPTED rather than replaced — createRoot on a
// populated container throws the whole tree away and repaints, which wastes
// the prerender and flashes. App routes are served the empty SPA shell and
// take the createRoot path exactly as before.
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, tree);
} else {
  ReactDOM.createRoot(rootElement).render(tree);
}
